// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about__r1ROO","title":"About_title__2F0pa"};